import { render, staticRenderFns } from "./PickCard.vue?vue&type=template&id=3ec87200&scoped=true"
import script from "./PickCard.vue?vue&type=script&lang=js"
export * from "./PickCard.vue?vue&type=script&lang=js"
import style0 from "./PickCard.vue?vue&type=style&index=0&id=3ec87200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec87200",
  null
  
)

export default component.exports